import React, { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { api } from '../../../app/Api/ApiSlice'
import { toast } from 'react-toastify'
import InfiniteScroll from 'react-infinite-scroll-component'
import Loader from '../../../components/Loader'
import AdminProductCard from '../../../components/AdminProductCard'

const StoreShelf = () => {
    const [shelfDetails, setShelfDetails] = useState({})
    const [products, setProducts] = useState([])
    const [loadingDetails, setLoadingDetails] = useState(false)
    const [loadingProducts, setLoadingProducts] = useState(false)
    const [hasMore, setHasMore] = useState(true)
    const [page, setPage] = useState(1)

    const location = useLocation()
    const { id } = location.state
    const { name } = useParams()
    const limit = 20

    useEffect(() => {
        getShelf()
    }, [])

    useEffect(() => {
        getShelfProducts()
    }, [page])

    const getShelf = async () => {
        try {
            setLoadingDetails(true)
            const response = await api.get(`/stores/${name}/manage/shelves/${id}`)
            if (response) {
                setShelfDetails(response.data)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to load shelf")
        } finally {
            setLoadingDetails(false)
        }
    }

    const getShelfProducts = async () => {
        try {
            setLoadingProducts(true)
            const response = await api.get(`/stores/${name}/manage/shelves/${id}/products`, {
                params: { page, limit },
            })
            const fetched = response.data

            // Append or reset depending on page
            if (page === 1) {
                setProducts(fetched)
            } else {
                setProducts(prev => [...prev, ...fetched])
            }

            // Check if there are more products to load
            setHasMore(fetched.length === limit)
        } catch (error) {
            toast.error(error?.response?.data?.message || "Failed to load products")
            setHasMore(false)
        } finally {
            setLoadingProducts(false)
        }
    }

    const handleRefresh = async () => {
        setPage(1)
    }

    return (
        <div>
            <div className="shelf-header">
                <h3>{shelfDetails.name}</h3>
                <p>{shelfDetails.description}</p>
            </div>

            <h3 className="shelf-products-title">Products</h3>
            <div className="shelf-products-container">
                {!loadingProducts && !products.length && (
                    <p className="not-found-msg">No products found</p>
                )}
                <InfiniteScroll
                    dataLength={products.length}
                    next={() => setPage(prev => prev + 1)}
                    hasMore={hasMore}
                    loader={<Loader />}
                    pullDownToRefresh
                    pullDownToRefreshThreshold={50}
                    refreshFunction={handleRefresh}
                >
                    {products.map(product => (
                        <AdminProductCard key={product._id} product={product} />
                    ))}
                </InfiniteScroll>
            </div>
        </div>
    )
}

export default StoreShelf
